const MetabotMode = {
  name: "public",
  drills: [],
};

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default MetabotMode;
